import { render, staticRenderFns } from "./r-reminder-dialog.vue?vue&type=template&id=fac8acb4&scoped=true"
import script from "./r-reminder-dialog.vue?vue&type=script&lang=js"
export * from "./r-reminder-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-reminder-dialog.vue?vue&type=style&index=0&id=fac8acb4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac8acb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fac8acb4')) {
      api.createRecord('fac8acb4', component.options)
    } else {
      api.reload('fac8acb4', component.options)
    }
    module.hot.accept("./r-reminder-dialog.vue?vue&type=template&id=fac8acb4&scoped=true", function () {
      api.rerender('fac8acb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/reminder/r-reminder-dialog.vue"
export default component.exports